import React, { Component } from "react";
import PropTypes from "prop-types";
import ValidateItem from "../../helpers/validation/validateInput";

const validatehoc = (WrappedComponent, type = "text") => {
	class Validator extends Component {
		render() {
			const validate = value => {
				const { placeholder, isRequired, validationRegex, minLength, maxLength, regexMessage } = this.props;
				return ValidateItem(
					value,
					placeholder,
					isRequired,
					validationRegex,
					minLength,
					maxLength,
					regexMessage,
					type
				);
			};
			return <WrappedComponent {...this.props} validate={validate} validateOnBlur validateOnChange />;
		}
	}

	Validator.propTypes = {
		field: PropTypes.string,
		id: PropTypes.string,
		placeholder: PropTypes.string,
		autocomplete: PropTypes.string,
		isRequired: PropTypes.bool,
		minLength: PropTypes.number,
		maxLength: PropTypes.number,
		validationRegex: PropTypes.string,
		regexMessage: PropTypes.string,
		type: PropTypes.string,
	};

	return Validator;
};

export default validatehoc;
